import { render, staticRenderFns } from "./pages-edit.vue?vue&type=template&id=0dbe0869"
import script from "./pages-edit.vue?vue&type=script&lang=js"
export * from "./pages-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports